import { t } from 'i18next'
import i18n from '@/application/i18n/config'

export enum FormattedDateMode {
  DateAndTimeWithSeconds = 'DATE_AND_TIME_WITH_SECONDS',
  DateAndTime = 'DATE_AND_TIME',
  Date = 'DATE',
  TimeWithSeconds = 'TIME_WITH_SECONDS',
  Time = 'TIME'
}

const getLocale = (): Intl.LocalesArgument => {
  return i18n.language
}

const getFormat = (mode: FormattedDateMode): Intl.DateTimeFormatOptions => {
  switch (mode) {
    case FormattedDateMode.DateAndTimeWithSeconds:
      return {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }
    case FormattedDateMode.DateAndTime:
      return {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }
    case FormattedDateMode.Date:
      return {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }
    case FormattedDateMode.TimeWithSeconds:
      return {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }
    case FormattedDateMode.Time:
      return {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }
  }
}

export const formatDate = (value?: Date, mode: FormattedDateMode = FormattedDateMode.DateAndTime): string => {
  if (!value) {
    return t('common.empty')
  }
  return new Intl.DateTimeFormat(getLocale(), getFormat(mode)).format(value)
}
